const H264_MIME_TYPE = 'video/h264';

export function isH264ProfileLevelIdSupported(h264ProfileLevelId: string) {
    const capabilities = window?.RTCRtpReceiver.getCapabilities('video');

    if (!capabilities) {
        return false;
    }

    return capabilities.codecs.some(
        ({ mimeType, sdpFmtpLine }) =>
            mimeType.toLowerCase() === H264_MIME_TYPE && sdpFmtpLine?.includes(h264ProfileLevelId)
    );
}
